<script lang="ts" setup>
type Props = {
  markingComposition: string
}

defineProps<Props>()
</script>

<template>
  <div class="compound">
    <the-tooltip position-x="right" position-y="center" width="250">
      <template #activator>
        <span class="button">Состав</span>
      </template>

      <div class="compound__text">
        <span class="compound__text-title">Состав</span>
        <span class="compound__text-content">{{ markingComposition }}</span>
      </div>
    </the-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.compound {
  width: max-content;
  font-size: 16px;
  font-weight: 600;
  color: var(--ui-primary);

  &__text {
    &-title {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 800;
      line-height: 18px;
      letter-spacing: 0;
    }

    &-content {
      display: inline-block;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      letter-spacing: 0;
    }
  }
}
</style>
